import { ValidationResult } from 'joi';

import { ValidationFunctionResult } from '../../../../shared/types/validation-function-result';
import { CreateLocationDto } from '../../dtos/create-location.dto';
import { UpdateLocationDto } from '../../dtos/update-location.dto';
import { createLocationSchema } from '../schemas/create-location.schema';
import { updateLocationSchema } from '../schemas/update-location.schema';

/**
 * Validates record data for creation or update.
 * @param record - The record to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const canCreateOrUpdate = (
  record: CreateLocationDto | UpdateLocationDto,
  abortEarly = false,
): ValidationFunctionResult => {
  // Check if record is provided
  if (!record) throw new Error('record is required.');

  let validationResult: ValidationResult | undefined;

  // Determine if it's an update or create operation by checking for 'id'
  if ('id' in record && record.id) {
    // Validate against updateLocationSchema if 'id' is present
    validationResult = updateLocationSchema().validate(record, {
      abortEarly,
    });
  } else {
    // Validate against createLocationSchema if 'id' is not present
    validationResult = createLocationSchema().validate(record, {
      abortEarly,
    });
  }

  // Check for validation errors
  if (validationResult?.error) {
    return {
      isValid: false,
      errors: validationResult.error.details?.map((e) => e.message),
    };
  }

  // Return valid result if no errors
  return { isValid: true };
};
